export default __webpack_public_path__ + "static/media/recepcion-cadaver.9399c4aa.svg";